/* eslint-disable no-unused-vars */
import React, { useEffect, useRef } from 'react';
import { Input } from 'antd';
import Delete from '../../assets/images/Delete.svg';

type Props = {
  recipe: any;
  index: any;
  handleAddRecipeStep: any;
  handleStepValue: any;
  handleDeleteRecipeStep: any;
  setActiveStepIndex?: any;
  activeStepIndex?: any;
  steps?: any;
  cookingMenu?: any;
};

const CookingMethodSteps = (props: Props) => {
  let {
    recipe,
    index,
    handleAddRecipeStep,
    handleStepValue,
    handleDeleteRecipeStep,
    setActiveStepIndex,
    activeStepIndex,
    steps,
    cookingMenu,
  } = props;

  let inputRefs = useRef<any>(recipe?.steps?.map(() => React.createRef()));

  console.log('steps', steps);

  useEffect(() => {
    if (cookingMenu && steps?.length > 0 && index === 0) {
      steps.forEach((step: string, stepIndex: number) => {
        handleStepValue({ target: { value: step } }, recipe, stepIndex);
      });
      if (inputRefs.current[0]) {
        inputRefs.current[0].focus();
      }
    }
  }, [cookingMenu, steps]);

  const handleKeyDown = (e: any, index: number, stepIndex: number) => {
    if (e.key === 'Enter') {
      handleAddRecipeStep(recipe, index);
      setTimeout(() => {
        inputRefs.current[stepIndex + 1]?.focus();
      }, 200);
    }
  };

  const handleFocus = (stepIndex: number) => {
    if (setActiveStepIndex) {
      setActiveStepIndex(stepIndex);
    }
  };

  return recipe?.steps?.map((step: any, stepIndex: number) => {
    return (
      <div key={stepIndex} className="form-group">
        <span>{stepIndex + 1}</span>
        <Input
          type="text"
          value={step}
          onChange={(e) => handleStepValue(e, recipe, stepIndex)}
          onKeyDown={(e: any) => handleKeyDown(e, index, stepIndex)}
          ref={(el) => (inputRefs.current[stepIndex] = el)}
        />
        {/* <div
          className="rich-text-step"
          contentEditable
          dangerouslySetInnerHTML={{ __html: step }}
          onInput={(e) => {
            requestAnimationFrame(() => {
              handleStepValue(
                { target: { value: e.currentTarget.innerHTML } },
                recipe,
                stepIndex
              );
            });
          }}
          onFocus={() => handleFocus(stepIndex)}
          onKeyDown={(e: any) => handleKeyDown(e, index, stepIndex)}
          ref={(el) => (inputRefs.current[stepIndex] = el)}
        /> */}
        <button onClick={() => handleDeleteRecipeStep(recipe, stepIndex)}>
          <img src={Delete} width={15} alt="" />
        </button>
      </div>
    );
  });
};

export default CookingMethodSteps;
